import { Language } from "../enum/Language";

export default class LanguageDto {
    id: number;
    value: string;
    language: Language;
    imageUrl: string;
    constructor(id: number, value: string, language: Language, imageUrl: string) {
        this.id = id;
        this.value = value;
        this.language = language;
        this.imageUrl = imageUrl;
    }
}